<div [class.active]="isFocus" class="title">{{title}}</div>
<div #divEl>
      <input *ngIf="!multiline" #valEl="ngModel" autofocus [(ngModel)]="model" [placeholder]="placeholder" (keyup)="valueChange(null)"
            [style.width]="textboxWidth"
            (focus)="isFocus=true"
            (blur)="onBlur()"
            (keyup.enter)="onEnter()"
            [class.active]="isFocus"
            [class.invalid]="valEl.invalid && valEl.touched"

            [attr.disabled]="disabled ? '' : null"
            [required]="required"
            [maxlength]="maxlength ? maxlength : null"
            [minlength]="minlength ? minlength : null"
            [pattern]="pattern ? pattern : null"
            [attr.type]="type"
            [attr.readonly]="readonly? '' : null"
            [attr.tabindex]="tabindex"
      />
      <textarea
            *ngIf="multiline" #valEl="ngModel" autofocus [(ngModel)]="model" [placeholder]="placeholder" (keyup)="valueChange(null)" [rows]="rows"
            [style.width]="textboxWidth"
            (focus)="isFocus=true"
            (blur)="onBlur()"
            (keyup.enter)="onEnter()"
            [class.active]="isFocus"
            [class.invalid]="valEl.invalid && valEl.touched"

            [attr.disabled]="disabled ? '' : null"
            [required]="required"
            [maxlength]="maxlength ? maxlength : null"
            [minlength]="minlength ? minlength : null"
            [pattern]="pattern ? pattern : null"
            [attr.type]="type"
            [attr.readonly]="readonly? '' : null"
            [attr.tabindex]="tabindex"
            class="thin-scroll"
      >
      </textarea>


</div>

